export const RESULTS_TITLE = 'Newspage Results: real searches, real results';
export const RESULTS_DESCRIPTION =
    "Dated examples of Newspage stories and sponsors' pages on page one of Google and in the AI Overview, searchable by sector.";

export const ALL_SECTORS = 'All';
export const RESULT_TYPES = ['AI Overview', 'Page one', "Sponsor's page"];

const NUMBER_WORDS = [
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
    'eleven',
    'twelve',
];

export const numberWord = (n) => NUMBER_WORDS[n] ?? String(n);

export const sectorsOf = (cases) => [...new Set(cases.map((c) => c.sector))];

export const aiOverviewCount = (cases) =>
    cases.filter((c) => c.resultTags.includes('AI Overview')).length;

// Every chosen result type must be on the case; the search runs over the visible text.
export const filterCases = (cases, { sector, types, query }) => {
    const q = (query || '').trim().toLowerCase();
    return cases.filter(
        (c) =>
            (sector === ALL_SECTORS || c.sector === sector) &&
            types.every((t) => c.resultTags.includes(t)) &&
            (!q ||
                [c.sector, c.search, c.headline, c.detail, c.who]
                    .join(' ')
                    .toLowerCase()
                    .includes(q))
    );
};
